<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="authentication-main">
          <div class="row">
            <div class="col-md-12 p-0">
              <div class="auth-innerright">
                <div class="reset-password-box col-10">
                  <div class="text-center">
                    <img alt="" src="../../../assets/images/logo_gms.png" style="width: 405px">
                  </div>
                  <div class="card mt-4 m-b-5" id="tracking_dispatch">
                    <div class="card">
                      <div class="card-body">
                        <h4><b>Inventario en Línea - {{client.business_name}}</b></h4>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <form class="form-inline d-flex mx-1 justify-content-end"
                              @submit.stop.prevent="">
                          <div class="input-group">
                            <input type="search" placeholder="Buscar" class="form-control"
                                   v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                            <div class="input-group-append">
                              <button type="submit" class="btn btn-outline-secondary">
                                <i class="mdi mdi-magnify" /> Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                        <div class="datatable-vue" v-if="datatableConfig !== null">
                          <vdtnet-table
                              ref="table"
                              :fields="datatableConfig.fields"
                              :opts="datatableConfig.options"
                          >
                          </vdtnet-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import VdtnetTable from 'vue-datatables-net';
import 'datatables.net-bs4';
import utils from '../../../utils';
import axios from "axios";
import Multiselect from "vue-multiselect";

window.jQuery = $;

export default {
  components: {
    VdtnetTable,
    Multiselect,
  },
  data(){
    return {
      clientName: null,
      client: null,
      clientId: null,
      datatableConfig: null,
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalTable);
  },
  mounted() {
    this.clientName = this.$route.params.clientName;
    this.loadData(this.clientName);
    this.intervalTable = setInterval(() => {
      this.$refs.table.reload();
    }, utils.timeRefresh * 1000);
  },
  methods: {
    reloadTable() {
      // ELIMINAOS EL INTERVALO
      clearInterval(this.intervalTable);
      // RECARGAMOS
      this.$refs.table.reload();
      // GENERAMOS EL INTERVALO
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    doSearch() {
      this.$refs.table.search(this.datatableConfig.quickSearch);
    },
    editClient(data){
      this.$router.push({'name': 'CoreClientFormEdit', params: { objectId: data['id'] }});
    },
    async editStatusObject(row) {
      let oldState = '';
      let newState = '';

      if(row['status']){
        oldState = 'Habilitado';
        newState = 'Deshabilitado';
      } else {
        oldState = 'Deshabilitado';
        newState = 'Habilitado';
      }

      this.$swal({
        title: 'Información',
        type: 'info',
        html: `Estás a punto de <b>cambiar el estado</b> del cliente <b>${row['business_name']}</b> de <b>${oldState}</b> a <b>${newState}</b>.`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: '#28a745',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
        cancelButtonColor: '#dc3545',
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const path = '/api/core/v1.0/client/' + row['id'] + '/';
          let data = {status: !row['status']};
          const response = await utils.updateObject(path, data);
          // SI SE REALIZA EL CAMBIO
          if (response) {
            await this.$swal({
              title: 'Editado!',
              type: 'success',
              html: `Se ha editado el estado de la categoría de manera correcta.`,
            });
            this.reloadTable();
          }
        }
      });
    },
    async loadData(pathName){
      let responseData;
      const path = `/api/core/v1.0/client/`;
      await axios.get(path, {params: {path_tracking: pathName}}).then(async (response) => {
        responseData = response.data[0];
      });
      await this.$set(
          this,
          'client',
          responseData
      );
      if (responseData !== undefined) {
        this.$set(
            this,
            'datatableConfig',
            {
              options: {
                lengthMenu: [10, 25, 50],
                pageLength: 10,
                lengthChange: false,
                processing: true,
                serverSide: true,
                searchDelay: 500,
                fixedHeader: true,
                responsive: true,
                ajax: {
                  url: axios.defaults.baseURL + `/api/inventory/v1.0/product/?format=datatables&deleted=false&category__status=true&category__deleted=false&client__status=true&client__deleted=false&client=${responseData.id}`,
                  type: "GET",
                  dataSrc: (json) => {
                    return json['data'];
                  }
                },
                language: {
                  decimal: "",
                  emptyTable: "No hay información",
                  info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                  infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                  infoFiltered: "",
                  infoPostFix: "",
                  thousands: ",",
                  lengthMenu: "Mostrar _MENU_ Entradas",
                  loadingRecords: "Cargando...",
                  processing: "Procesando...",
                  search: "Buscar:",
                  zeroRecords: "Sin resultados encontrados",
                  paginate: {
                    first: "Primero",
                    last: "Ultimo",
                    next: "Siguiente",
                    previous: "Anterior"
                  }
                },
                "drawCallback": function () {
                  // const num_row = $('.dataTables_length');
                  $('div.vdtnet-container').removeClass('table-responsive');
                  // num_row.find('select').removeClass('custom-select form-control');
                  $('.dataTables_paginate').addClass('pull-right mt-2');
                  $('.dataTables_info').addClass('mt-2');
                },
              },
              fields: {
                id: {
                  data: 'id',
                  name: 'id',
                  visible: false,
                  searchable: true,
                },
                full_name: {
                  data: 'full_name',
                  name: 'full_name',
                  visible: false,
                  sortable: false,
                  searchable: true,
                },
                type: {
                  data: 'type',
                  name: 'type',
                  visible: false,
                  searchable: true,
                },
                pack_name: {
                  data: 'pack_name',
                  name: 'pack_name',
                  visible: false,
                  searchable: true,
                },
                image: {
                  name: 'image',
                  label: 'Imagen',
                  data: 'image',
                  sortable: false,
                  searchable: false,
                  render: function (data, type, row) {
                    return `<img class="img-thumbnail" alt="imagen del producto" style="width: 90px" src="${row['image'].replace('http', 'https')}"/>`;
                  }
                },
                name: {
                  name: 'category__name',
                  label: 'Producto',
                  data: 'name',
                  sortable: true,
                  searchable: true,
                  render: function (data, type, row) {
                    if (data) return data;
                    return row['pack_name'];
                  }
                },
                category: {
                  name: 'category__name',
                  label: 'Categoría',
                  data: 'category.name',
                  sortable: true,
                },
                invoice_stock: {
                  name: 'invoice_stock',
                  label: 'Total de productos',
                  data: 'invoice_stock',
                  sortable: true,
                },
                invoice_stock_busy: {
                  name: 'invoice_stock_busy',
                  label: 'Productos en uso',
                  data: 'invoice_stock_busy',
                  sortable: true,
                },
              },
              quickSearch: '',
            }
        );
      }
    }
  },
}
</script>
